import { ISelectionServiceProvider } from "@zebrabi/selection-service";
import { applyExcelSLicers } from "@zebrabi/data-helpers/slicers";
import { Visual } from "./visual";

export interface ISelectionId {
    //todo: check and possibly replace existing ISelectionId interface from legacy-library-common
    equals(other: ISelectionId): boolean;
    getKey(): string;
    // the following are not used in the Office atm
    includes(other: ISelectionId, ignoreHighlight?: boolean): boolean;
    getSelector(): any;
    getSelectorsByColumn(): any;
    hasIdentity(): boolean;
}

export type ChartsSelectionItem = ISelectionId;
export type ChartsSelection = ChartsSelectionItem[];

// Class instead of an object literal with closures: charts structuredClone()s chart data
// (group-title focus popup), and own-property functions make it throw — prototype methods don't.
export class OfficeSelectionId implements ISelectionId {
    constructor(private category: string) {}

    equals(other: ISelectionId): boolean {
        return other?.getKey?.() === this.category;
    }
    getKey(): string {
        return this.category;
    }
    includes(other: ISelectionId): boolean {
        return other?.getKey?.() === this.category;
    }
    getSelector(): any {
        return null;
    }
    getSelectorsByColumn(): any {
        return null;
    }
    hasIdentity(): boolean {
        return !!this.category;
    }
}

export class OfficeSelectionService implements ISelectionServiceProvider {
    selectionRegistry: unknown = null;

    selectedCategories: string[] = [];
    isFilterApplied(): boolean {
        return this.selectedCategories?.length > 0;
    }

    isFilteringEnabled(): boolean {
        return this.isExcel;
    }

    constructor(private isExcel: boolean) {}

    public getSelection(): ChartsSelection {
        return this.selectedCategories.map((category) => new OfficeSelectionId(category));
    }

    public hasSelection(): boolean {
        return this.selectedCategories?.length > 0;
    }

    public select(selection: any, multiSelect?: boolean): Promise<any> {
        console.log("select", selection, multiSelect); ///todo: test after new charts is integrated
        if (this.isFilteringEnabled) {
            return applyExcelSLicers(
                selection?.[0]?.getKey(),
                Visual.dataView?.categories?.[0]?.source?.displayName,
                multiSelect ?? false
            ).then((result) => {
                this.selectedCategories = result;
                return this.getSelection();
            });
        } else {
            return Promise.resolve([]);
        }
    }

    public clear(): Promise<void> {
        if (this.isFilterApplied()) {
            return applyExcelSLicers("", Visual.dataView?.categories?.[0]?.source?.displayName, false).then((result) => {
                this.selectedCategories = result;
            });
        } else {
            return Promise.resolve();
        }
    }

    public showContextMenu(selection: ISelectionId[], position: { x: number; y: number }, dataRoles?: string): Promise<void> {
        return Promise.resolve();
    }

    public toggleExpandCollapse(selection: ISelectionId, entireLevel?: boolean): Promise<void> {
        return Promise.resolve();
    }

    public setSelectionRegistry(registry: unknown): void {
        this.selectionRegistry = registry;
    }
}
